import { Modal } from "antd";
import TextLink from "components/UI/TextLink/TextLink";
import { useState } from "react";
import { Element } from "react-scroll";
import {
    ModalDescription
} from "./ModalDetailRoom.style";
import RoomDescription from "./RoomDescription";


const ModalDetailRoom = ({icon, style, libelle, images, id, hotel, dayUseParams}) => {
    const [state, setState] = useState({
        modalDetailRoom: false,
    });

  const handleModalClose = (key) => {
    setState({ ...state, [key]: false });
  };

  const handleModalOpen = (key) => {
    setState({ ...state, [key]: true });
  };

    return (
    <ModalDescription>
        <Element name="modalDetailRoom" className="modalDetailRoom">
        <TextLink
            icon={icon}
            onClick={() => handleModalOpen("modalDetailRoom")}
            style={style}
            content={libelle}
        />
        <Modal
            open={state.modalDetailRoom}
            onCancel={() => handleModalClose("modalDetailRoom")}
            footer={null}
            width="100%"
            maskStyle={{ backgroundColor: "rgba(255, 255, 255, 0.9)" }}
            wrapClassName="review_modal"
            className="modal-detail-room"
            bodyStyle={{padding: "30px 0px 0px 0px"}}
            style={{margin: "auto", top: "80px"}}
        >
            <RoomDescription images={images} id={id} hotel={hotel} dayUseParams={dayUseParams} />
        </Modal>
    </Element>
    </ModalDescription>
    );
};

export default ModalDetailRoom;
